import * as React from "react";
import { Fragment } from "react";
import {
  IFilterData,
  BaseListComponentState,
} from "../../../components/BaseListComponent";
import {
  createFilterData,
  mapEntityList,
} from "./../../../services/utility/autoMapperService";
import BaseListComponent from "./../../../components/BaseListComponent";
import thirdPartyAccountConfigService from "../../../services/billing/thirdPartyAccountConfigService";
import ItemsTable, {
  filterFieldData,
} from "../../../components/tableComponents/itemsTable";
import TableFilterPane from "./../../../components/tableComponents/tableFilterPane";
import ThirdPartyAccountConfigurationDetail from "./thirdPartyAccountConfigurationDetail";
import { getCurrentUsersRoles } from "../../../services/auth/authService";
import EditThirdPartyAccountConfiguration from "./editThirdPartyAccountConfiguration";
import institutionService from "../../../services/auth/institutionsService";

export interface ThirdPartyAccountConfigurationsProps {}

export interface ThirdPartyAccountConfigurationsState extends BaseListComponentState {
  data: IFilterData;
  currentPage: number;
  pageSize: number;
  tableItems: any;
  totalSize: number;
  fetchingDetail: boolean;
  filterValueInput: filterFieldData;
  item: any;
}

class ThirdPartyAccountConfigurationsList extends BaseListComponent<ThirdPartyAccountConfigurationsState> {}

class ThirdPartyAccountConfigurations extends React.Component<ThirdPartyAccountConfigurationsProps, ThirdPartyAccountConfigurationsState> {
  constructor(props: ThirdPartyAccountConfigurationsProps) {
    super(props);
    this.state = {
      data: createFilterData([]) as IFilterData,
      currentPage: 1,
      pageSize: Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
      fetching: false,
      fetchingDetail: false,
      tableItems: [],
      totalSize: 0,
      filterValueInput: [],
      item: {},
      showDetailsModal: false,
      showEditModal: false,
      showTableFilterModal: false,
      showTrailModal: false,
    };
  }

  handlePageChange = async (currentPage: number, pageSize:number, data?: IFilterData) => {
    currentPage = currentPage < 0 ? this.state.currentPage : currentPage;
    pageSize = pageSize < 0 ? this.state.pageSize : pageSize;
    this.setState({ fetching: true });
    try {
      const thirdPartyAccountConfigList = await thirdPartyAccountConfigService.retrieveThirdPartyAccountConfig();
      const thirdPartyAccountConfigs: any = [];
      const totalLength = thirdPartyAccountConfigList.data.length;
      const initial = (currentPage - 1) * pageSize;
      for (let i = initial; i < initial + pageSize; i++) {
        if (i === totalLength) {
          break;
        }
        thirdPartyAccountConfigs.push(thirdPartyAccountConfigList.data[i]);
      }

      this.setState({
        tableItems: mapEntityList({
          entityList: thirdPartyAccountConfigs,
          properties: [
            { oldName: "thirdPartyAccountConfigurationId", newName: "id" },
            { oldName: "institutionCode", newName: "institutionCode" },
            { oldName: "thirdParty", newName: "thirdParty" },
            { oldName: "bank", newName: "bank" },
            { oldName: "bankCode", newName: "bankCode" },
            { oldName: "accountNumber", newName: "accountNumber" },
          ],
        }),
        currentPage,
        pageSize,
        totalSize: totalLength,
        fetching: false
      });
    } catch (ex) {
      // console.log("caught exception", ex);
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 499
      ) {
        // toast.error("Bad Request");
        // console.log(ex.response);
        // errors["response"] = "Internal server error.";
        // console.log(errors);
        this.setState({ fetching: false });
      } else {
        // toast.error("Internal server error. Please contact the admin.");
        this.setState({ fetching: false });
      }
    } finally {
      this.setState({ fetching: false });
    }
  };

  handleOnExport = async () => {};

  fetchItemById = async (item: any) => {
    this.setState({ fetchingDetail: true });
    const config = await thirdPartyAccountConfigService.filterThirdPartyAccountConfig(item.institutionCode, item.thirdParty)
    const institution = await institutionService.retrieveInstitutionByCode(item.institutionCode)
    config.data[0].institutionName = institution.data.name
    this.setState({ item: config.data[0], fetchingDetail: false });
  };

  getFilteredItems = (data: IFilterData): IFilterData => {
    let filteredItems: IFilterData = {};
    Object.keys(data).forEach((key) => {
      if (data[key].item2 !== "") {
        filteredItems[key] = data[key];
      }
    });
    return filteredItems;
  };

  async componentDidMount() {
    this.handlePageChange(this.state.currentPage, this.state.pageSize);
  }

  render() {
    const {
      data,
      currentPage,
      pageSize,
      tableItems,
      totalSize,
      fetching,
      item,
      fetchingDetail,
    } = this.state;
    return (
      <Fragment>
        <div className="container-fluid relative animatedParent animateOnce">
          <div className="animated fadeInUpShort go">
            <div className="row my-3 mx-2">
              <h3>
                <b>Third Party Account Configurations</b>
              </h3>
            </div>
            <ThirdPartyAccountConfigurationsList
              pageChangeHandler={this.handlePageChange}
              fetchingDetail={fetchingDetail}
              initialValues={{
                data: createFilterData([]) as IFilterData,
                fetching: false,
                showDetailsModal: false,
                showEditModal: false,
                showTableFilterModal: false,
                showTrailModal: false,
                tableItems: [],
                filterValueInput: [],
                item: {},
                jsonBefore: {},
                jsonAfter: {},
                fetchingTrail: false,
              }}
              tableItems={tableItems}
              item={item}
              DetailsModal={({
                item,
                onToggleDetailsModal,
                onToggleEditModal,
                showDetailsModal,
                showEditModal,
                fetchTrailItem,
                fetchingTrail,
                jsonAfter,
                jsonBefore,
                onToggleTrailModal,
                showTrailModal,
                trailItem,
                trailMapper,
              }) => (
                <Fragment>
                  <ThirdPartyAccountConfigurationDetail
                    showDetailsModal={showDetailsModal}
                    toggleDetailsModal={onToggleDetailsModal}
                    toggleEditModal={onToggleEditModal}
                    showTrail={() => onToggleTrailModal(item)}
                    currentUserRoles={getCurrentUsersRoles()}
                    item={item}
                  />
                  <EditThirdPartyAccountConfiguration
                    showEditModal={showEditModal}
                    toggleEditModal={(reloadDetails: boolean, item: any) => {
                      onToggleEditModal();
                      if (reloadDetails === true) {
                        this.fetchItemById(item);
                      }
                      this.setState({
                        showDetailsModal: !this.state.showDetailsModal,
                      });
                    }}
                    item={item}
                  />
                </Fragment>
              )}
              ListPayLoad={({
                data,
                showTableFilterModal,
                tableItems,
                onToggleDetailsModal,
                onToggleTableFilterModal,
                onHandleFilterItemRemove,
                filterValueInput,
              }) => (
                <div className="row">
                  <div className="col-md-12">
                    <div className="card no-b">
                      <div className="card-body">
                        <div className="card-title">
                          <div id="list-filters" className="ml-4 mr-4">
                            <TableFilterPane
                              filteredItems={this.getFilteredItems(data)}
                              handleFilterRemove={onHandleFilterItemRemove}
                            />
                          </div>
                          <div id="list-table">
                            <ItemsTable
                              data={data}
                              items={tableItems}
                              filterValueInput={filterValueInput}
                              showTableFiltermodal={showTableFilterModal}
                              toggleTableFiltermodal={onToggleTableFilterModal}
                              name="Third Party Account Configurations"
                              currentPage={currentPage}
                              pageSize={pageSize}
                              totalSize={totalSize}
                              fetching={fetching}
                              handlePageChange={this.handlePageChange}
                              onViewDetails={(item: any) => {
                                this.fetchItemById(item);
                                onToggleDetailsModal();
                              }}
                              handleOnExport={this.handleOnExport}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            ></ThirdPartyAccountConfigurationsList>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ThirdPartyAccountConfigurations;
